// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"560a1234","621":"f8ce183b"}[chunkId] + ".chunk.css";
};